
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"39","height":"39"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"2.003","y":"1.995","width":"34.37","height":"35.005","filterUnits":"userSpaceOnUse"}},[_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2.5","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#151924","flood-opacity":".251"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})]),_c('filter',{attrs:{"id":"b","x":"0","y":"0","width":"39","height":"39","filterUnits":"userSpaceOnUse"}},[_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2.5","result":"blur-2"}}),_c('feFlood',{attrs:{"flood-color":"#151924"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur-2"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"data-name":"moon"}},[_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Vector","d":"M9.527 19.925a10.506 10.506 0 0018.93 5.3c.82-1.11.38-1.85-.99-1.6a9.494 9.494 0 01-2.08.14 9.324 9.324 0 01-8.91-9.12 8.9 8.9 0 01.75-3.65c.54-1.24-.11-1.83-1.36-1.3a10.3 10.3 0 00-6.34 10.23z","fill":"#151924"}})])])])
          )
        }
      }
    